<template>
  <div class="edit-ads">
    <el-dialog :title="driverTitle" top="5vh" :visible.sync="driverDialogFormVisible" width="600px" @close="closeDriverAddHandle">
      <el-form :model="driverForm" :rules="driverRules" ref="driverform" status-icon :show-message="false" label-position="top">
        <el-form-item label="Name" prop="name" required>
          <el-input v-model="driverForm.name" type="text" placeholder="Input the driver's name"></el-input>
        </el-form-item>
        <el-form-item label="Phone number (Used to log in)" prop="phone" required>
          <el-input v-model="driverForm.phone"
                    @input="handleInput"
                    type="text"
                    placeholder="Input the driver's phone number">
            <template slot="prepend">+ 1</template>
          </el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email" required>
          <el-input v-model="driverForm.email" type="text" placeholder="Input the driver's email"></el-input>
        </el-form-item>
        <div class="flex gap-4">
          <div  style="width:50%;">
            <el-form-item label="SIN#" required>
              <el-select v-model="driverForm.sin_type" placeholder="Select driver's SIN#">
                <el-option
                  v-for="(item, index) in sinOption"
                  :label="item.label" :value="item.id" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div  style="width:50%;">
            <el-form-item label="SIN" class="hidden-label" prop="sin" required>
              <el-input v-model="driverForm.sin" type="text" placeholder="Input the driver's SIN#"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item v-if="driverForm.sin_type === 'Business'" label="Company name or Individual name for HST# " prop="company_name" required>
          <el-input v-model="driverForm.company_name" type="text" placeholder="Input the company's name"></el-input>
        </el-form-item>
        <el-form-item label="Upload the SIN# document">
          <ra-img-upload :width="222" :height="140" :uploadApiPath="'/adminapi/uploadDriverDoc'" type="sin" v-model="driverForm.sin_document_url"></ra-img-upload>
        </el-form-item>
        <el-form-item label="Driver's licence number" prop="license_number" required>
          <el-input v-model="driverForm.license_number" type="text" placeholder="Input the driver's licence number"></el-input>
        </el-form-item>
        <el-form-item label="Upload the driver's licence" required>
          <ra-img-upload :width="222" :height="140" :uploadApiPath="'/adminapi/uploadDriverDoc'" type="license" v-model="driverForm.license_document_url"></ra-img-upload>
        </el-form-item>
        <el-form-item label="Residency status" prop="residency_status" required>
          <el-select v-model="driverForm.residency_status" placeholder="Select residency status" @change="changeImgLabelHanlde">
            <el-option
              v-for="(item, index) in residencyOption"
              :label="item.label" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="driverLabel" required>
          <ra-img-upload :width="222" :height="140" :uploadApiPath="'/adminapi/uploadDriverDoc'" type="residency" v-model="driverForm.residency_document_url"></ra-img-upload>
        </el-form-item>
        <div class="flex gap-4">
          <div style="width:50%;">
            <el-form-item label="Metropolitan area code" prop="ma_code" required>
              <el-select v-model="driverForm.ma_code"
                         @change="changeSelectHandle"
                         placeholder="Select metropolitan area code">
                <el-option
                  v-for="(item, index) in maCodeOption"
                  :label="item.ma_code +' ' + item.ma_name" :value="item.ma_code" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div  style="width:50%;">
            <el-form-item label="Zone code" prop="zone_codes">
              <el-select
                multiple
                collapse-tags
                v-model="driverForm.zone_codes" placeholder="Select zone code">
                <el-option
                  v-for="(item, index) in zoneCodeOptions"
                  :label="item.zone_code" :value="item.zone_code" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelHandler" plain class="w-[80px] changeFocus p-0 border-black text-black">Cancel</el-button>
        <el-button type="success" @click="submitHandler" class="w-[80px] p-0">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RaImgUpload from "@/components/ra-img-upload.vue";
import { addDriver, editDriver } from "@/api/driver";
import { getMADropdownList, getZoneList } from '@/api/zipCode';

export default {
  components: { RaImgUpload },
  props: {
    id: String,
    driverTitle: {
      type: String,
      default: "Create a driver"
    },
    driverInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      driverLabel:"work permit document.",
      driverForm: {
        name: "",
        phone: '',
        email: "",
        company_name: '',
        sin: '',
        license_number: '',
        ma_code: '',
        sin_type: 'Individual',
        residency_status: "Canadian Citizenship",
        sin_document_url: '',
        license_document_url: '',
        residency_document_url: '',
        zone_codes: []
      },
      sinOption: [
        { label: "Individual", id: 'Individual' },
        { label: "Business", id: 'Business' },
      ],
      residencyOption: [
        { label: "Canadian Citizenship", id: 'Canadian Citizenship' },
        { label: "Permanent Residency", id: 'Permanent Residency' },
        { label: "Work permit", id: 'Work permit' },
      ],
      driverRules: {
        name: [
          { required: true, message: 'Please input the driver\'s name', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '手机号码不能为空', trigger: 'blur' },
          {
            validator: this.validatePhone,
            message: '请输入有效的加拿大手机号码',
            trigger: 'blur',
          },
        ],
        email: [
          { required: true, message: 'Please input the driver\'s email', trigger: 'blur' },
          {  validator: this.validateEmail, message: 'Please enter a valid email address', trigger: 'blur' },
        ],
        sin: [
          { required: true, message: 'Please input the driver\'s SIN#', trigger: 'blur' },
        ],
        company_name: [
          { required: true, message: 'Please input the company name or individual name', trigger: 'blur' },
        ],
        license_number: [
          { required: true, message: 'Please input the driver\'s licence number', trigger: 'blur' },
        ],
        residency_status: [
          { required: true, message: 'Please select residency status', trigger: 'change' },
        ],
        ma_code: [
          { required: true, message: 'Please select metropolitan area code', trigger: 'change' },
        ],
        zone_codes: [
          { required: true, message: 'Please select zone code', trigger: 'change' },
        ],
      },
      driverDialogFormVisible: false,
      maCodeOption: [],
      zoneCodeOptions: []
    }
  },
  created() {
    if (this.driverInfo && this.driverInfo.id) {
      // 使用深拷贝
      this.driverForm = JSON.parse(JSON.stringify(this.driverInfo));
    }
    getMADropdownList().then(res => {
      this.maCodeOption = res.data.list;
      // this.getZoneListHandle(this.maCodeOption[0].ma_code);
    });
  },

  methods: {
    handleInput(value) {
      // 过滤非数字字符
      this.driverForm.phone = value.replace(/\D/g, '');
    },
    validateEmail(rule, value, callback){
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!regex.test(value)) {
        this.$message({
          type:'warning',
          message:'Please enter a valid email'
        })
        callback(new Error('请输入有效的加拿大手机号码'));
      }else{
        callback();
      }

    },
    validatePhone(rule, value, callback) {
      // 校验加拿大手机号码格式
      const regex = /^\d{10}$/; // 这里假设是10位数字
      if (!regex.test(value)) {
        this.$message({
          type:'warning',
          message:'Please enter a valid mobile phone number'
        })
        callback(new Error('请输入有效的加拿大手机号码'));
      } else {
        callback();
      }
    },
    getZoneListHandle(code) {
      // 根据 metropolitan area code 获取 zone codes
      getZoneList({
        page: 1,
        limit: 1000,
        ma_code: code,
      }).then(res => {
        if (res.code === 200) {
          this.zoneCodeOptions = res.data.list;
          this.$refs.driverform?.clearValidate('zone_codes'); // 清除 zone_codes 的验证
        }
      });
    },
    cancelHandler() {
      // 关闭弹框
      this.driverDialogFormVisible = false;
    },
    closeDriverAddHandle() {
      // 关闭弹框时重置表单数据
      this.resetForm();
    },
    changeImgLabelHanlde(val){
      console.log(val,'ddd')
      if (val == 'Canadian Citizenship'){
        this.driverLabel = 'Upload the related document for Canadian Citizenship, like passport or birth certificate.'
      }else if (val == 'Permanent Residency'){
       this.driverLabel = 'Upload the related document for Permanent Residency, like PR Card or COPR letter etc.'
      }else{
        this.driverLabel = 'Upload work permit document.'
      }
    },
    changeSelectHandle(val) {
      this.driverForm.zone_codes = ''
      // 处理 metropolitan area code 的变化
      this.getZoneListHandle(val);
    },
    resetForm() {
      // 重置表单为空
      this.driverForm = {
        name: "",
        phone: '',
        email: "",
        company_name: '',
        sin: '',
        license_number: '',
        ma_code: '',
        sin_type: 'Individual',
        residency_status: "Canadian Citizenship",
        sin_document_url: '',
        license_document_url: '',
        residency_document_url: '',
        zone_codes: []
      };
      this.$nextTick(()=>{
        this.$refs.driverform?.clearValidate(); // 清除表单验证状态
      })
    },
    openDriverDialog() {
      // 打开弹框时根据模式设置表单数据
      if (this.driverTitle === 'Edit a driver' && this.driverInfo && this.driverInfo.id) {
        // 编辑模式：回显数据
        this.driverForm = JSON.parse(JSON.stringify(this.driverInfo));
      } else {
        // 新增模式：重置表单为空
        this.resetForm();
      }
      this.driverDialogFormVisible = true; // 打开弹框
    },
    submitHandler() {
      // 提交表单
      this.$refs.driverform.validate((valid) => {
        if (valid) {
          if (this.driverTitle === 'Create a driver') {
            // 新增模式
            addDriver(this.driverForm).then(res => {
              if (res.code === 200) {
                this.driverDialogFormVisible = false; // 关闭弹框
                this.$emit('updateList'); // 更新列表
                this.$message({
                  type: 'success',
                  message:'Successfully saved'
                });
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                });
              }
            });
          } else {
            // 编辑模式
            this.driverForm.id = this.driverInfo.id; // 设置编辑的 ID
            editDriver(this.driverForm).then(res => {
              if (res.code === 200) {
                this.driverDialogFormVisible = false; // 关闭弹框
                this.$emit('updateList'); // 更新列表
                this.$message({
                  type: 'success',
                  message: res.msg
                });
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                });
              }
            });
          }
        }else{
          this.$message({
            type:"warning",
            message:"Some information missing"
          })
        }
      });
    }
  },

  watch: {
    driverDialogFormVisible:{
      handler(val){
        if (val){
          if (this.driverTitle == 'Edit a driver'){
            console.log(this.driverDialogFormVisible,'driverDialogFormVisible')
              this.driverForm = JSON.parse(JSON.stringify(this.driverInfo));
              this.getZoneListHandle( this.driverForm.ma_code)
          }
        }
      },
      immediate: true,
      deep: true
    },
    //
    // couponsDialogFormVisible(val) {
    //   // 关闭弹窗
    //   if (!val) {
    //     this.clearData()
    //     this.$nextTick(() => {
    //       this.$refs.form.clearValidate();
    //       this.valid = false
    //     })
    //   } else {
    //     this.couponsTitle = this.row.id ? 'Edit a reward' : 'Create a reward'
    //     // 编辑优惠券
    //     if (Object.keys(this.row) && this.row.id) {
    //       Object.keys(this.couponsForm).forEach((key) => {
    //         if (this.row[key]) {
    //           this.couponsForm[key] = this.row[key]
    //         }
    //       })
    //       this.copyData()
    //     }
    //     // 复制优惠券
    //     if (Object.keys(this.row) && !this.row.id) {
    //       this.copyData()
    //     }
    //   }
    // }
    //

    driverTitle:{
      handler(val){
        if (val == 'Edit a driver'){
          // this.getDriverInfoHandle(this.driverForm.id)
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="less" scoped>
.edit-ads {
  .container_size{
    //width: 339px;
    //height: 184px;
  }
  .icon_box{
    position: absolute;
    top: 0;
    left: 0;
    padding: 0 79px;
    background: rgba(0, 0, 0, 0.5);
    color: #FFFFFF;
    font-size: 12px;
    justify-content: space-between;
    align-items: center;
    .container_size();
    border-radius: 16px;
    & > span{
      height: 38px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    }
    img{
      width: 16px;
      height: 16px;
    }
  }
  /deep/ .el-upload{
    .container_size()
  }
}
.hidden-label {
  /deep/.el-form-item__label {
    visibility: hidden!important;
  }

}
</style>
